import React, { useState, useEffect } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";

import { voucherTypesActions, vouchersActions, useSelector } from "inbooma-api"; // necessary to communicate with inbooma-react api
import { Biscuit, getAllUrlParams } from "../../../../utils"; // necessary to communicate with inbooma-react
import { _, $, moment } from "../../../../../vendor";

import de from "date-fns/locale/de";
import DatePicker from "react-datepicker";
import SwitchPaddle from "../../../components/switchpaddle";
import ContingentsChange from "./ContingentsChange";
import XLSX from "xlsx";
import ComboSelect from "../../../components/ComboSelect";
import MultiSelectWithContextMenu from "../../../components/MultiSelectWithContextMenu";
import { getDocHandler } from "../../../../utils/Helper";

const ItemView = (props) => {
  const {
    dispatch,
    filterChangedHandle,
    filter,
    showNotification,
    requestPath,
    voucher,
    setIndex,
    setAdd,
    setVoucher,
    setVouchersPending,
    type,
  } = props;

  const emptyVoucherType = {
    id: null,
    client_id: Number(Biscuit.get("user.client_id")),
    name: "",
    description: "",
    status: true,
    type: type,
    voucher_unit: "percentage",
    voucher_value: 0,
    contingent_number: 0,
    multiple_use: true,
    sellable: false,
    days_number: 0,
    valid_to: null,
    use_for: null,
    vouchers: [],
    contingents: [],
  };

  const emptyVoucher = {
    id: null,
    client_id: Number(Biscuit.get("user.client_id")),
    voucher_type_id: null,
    voucher_code: "",
    usage_count: 0,
    last_order_id: null,
  };

  const [voucherType, setVoucherType] = useState(
    typeof voucher.id === "undefined" ? emptyVoucherType : voucher,
  );
  const fill = (vouchers, type) => {
    let codesArr = [];
    if (vouchers.length < 1) {
      return codesArr;
    }
    vouchers.map((v) => {
      switch (type) {
        case "codes":
          codesArr.push({
            value: v.id,
            label: v.voucher_code,
            disabled: true,
          });
          break;
        case "counts":
          codesArr[v.id] = v.usage_count !== null ? v.usage_count : 0;
          break;
      }
    });
    return codesArr;
  };

  let language = Biscuit.get("user.lang").replace("-", "_");
  const [timespan, setTimespan] = useState({
    valid_to:
      voucherType.valid_to !== null
        ? new Date(moment(voucherType.valid_to).format("YYYY-MM-DD"))
        : null,
  }); // init, saving
  const _patchVoucherType = useSelector((state) => state.voucher_types_data.patchVoucherType); // used for after save process
  const _postVoucherType = useSelector((state) => state.voucher_types_data.postVoucherType); // used for after save process
  const _addVoucher = useSelector((state) => state.vouchers_data.postVoucher);
  const _user = useSelector((state) => state.users_data.user);
  const [userPending, setUserPending] = useState(false);
  const [voucherPending, setVoucherPending] = useState(false);
  const [voucherTypePending, setVoucherTypePending] = useState(false);
  const [codesGenerate, setCodesGenerate] = useState("-");
  const [codesArea, setCodesArea] = useState("");
  const [getCodesPending, setGetCodesPending] = useState(false);
  const [voucherCodesToGenerate, setVoucherCodesToGenerate] = useState(null);
  const [createdBy, setCreatedBy] = useState({
    id: null,
    first_name: "",
    last_name: "",
  });
  const [modifiedBy, setModifiedBy] = useState({
    id: null,
    first_name: "",
    last_name: "",
  });
  const _getCodes = useSelector((state) => state.vouchers_data.getCodes);
  const [codes, setCodes] = useState(null);
  const [files, setFiles] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const [amounts, setAmounts] = useState(null);
  const [codesPending, setCodesPending] = useState(false);
  const [amountsPending, setAmountsPending] = useState(false);
  const currentUrl = new URL(window.location.href);
  console.log("type", type);
  useEffect(() => {
    if (initialized) return;
    if (typeof voucher.id !== "undefined" && voucher.vouchers.length > 0) {
      setCodesPending(true);
      setCodes(fill(voucher.vouchers, "codes"));
      setAmountsPending(true);
      setAmounts(fill(voucher.vouchers, "counts"));
    }
    setInitialized(true);
  }, []);

  useEffect(() => {
    if (_getCodes.success === "" || !getCodesPending) {
      return;
    }
    if (_getCodes.success === true) {
      let v = [];
      if (voucherType.vouchers.length > 0) {
        v = voucherType.vouchers;
        v.map((va, key) => {
          if (isNaN(va.id) && va.id.includes("code")) {
            delete v[key];
          }
        });
      }
      Object.keys(_getCodes.data).map((val) => {
        v.push({
          id: val,
          voucher_code: _getCodes.data[val],
          usage_count: 0,
        });
      });
      setCodes(null);
      setAmounts(null);
      setCodesPending(true);
      setCodes(fill(v, "codes"));
      setAmountsPending(true);
      setAmounts(fill(v, "counts"));
    }
    setGetCodesPending(false);
  }, [_getCodes]);

  useEffect(() => {
    if (!codesPending || codes === null) {
      return;
    }
    setCodesPending(false);
  }, [codesPending]);

  useEffect(() => {
    if (!amountsPending || amounts === null) {
      return;
    }
    setAmountsPending(false);
  }, [amountsPending]);

  const saveVouchers = (voucherTypeId) => {
    let codesToSave = [];
    if (codes !== null) {
      Object.keys(codes).map((key) => {
        if (!_.isNumber(codes[key].value) && codes[key].value.includes("code")) {
          codesToSave.push({ code: codes[key].label });
        }
      });
    }
    const vouch = {
      voucher_type_id: voucherTypeId,
      client_id: Biscuit.get("user.client_id"),
      codes: codesToSave,
    };
    dispatch(
      vouchersActions.addVoucher({
        token: Biscuit.get("token"),
        data: vouch,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setVoucherPending(true);
  };

  useEffect(() => {
    if (_addVoucher.success === "" || !voucherPending) {
      return;
    }
    if (_addVoucher.success) {
      showNotification("success", voucherType.id);
      close();
    } else {
      showNotification(
        "warning",
        null,
        t("error by saving voucher") +
          (typeof _addVoucher.data.message !== "undefined" ? " " + _addVoucher.data.message : ""),
      );
    }
    setVoucherPending(false);
  }, [_addVoucher]);

  useEffect(() => {
    if (_patchVoucherType.success === "" || !voucherTypePending) {
      return;
    }
    if (_patchVoucherType.success) {
      setVoucherType(_patchVoucherType.data);
      saveVouchers(_patchVoucherType.data.id);
    } else {
      showNotification("warning", voucherType.id, _patchVoucherType.data.message);
    }
    setVoucherTypePending(false);
  }, [_patchVoucherType]);

  useEffect(() => {
    if (_postVoucherType.success === "" || !voucherTypePending) {
      return;
    }
    if (_postVoucherType.success) {
      let clone = {};
      Object.assign(clone, voucherType);
      clone.id = _postVoucherType.data.id;
      setVoucherType(clone);
      saveVouchers(_postVoucherType.data.id);
    } else {
      showNotification("warning", null, _patchVoucherType.data.message);
    }
    setVoucherTypePending(false);
  }, [_postVoucherType]);

  // evaluate form and send resource to api
  const onSubmit = () => {
    let clone = {};
    Object.assign(clone, voucherType);

    clone["valid_to"] = moment(clone["valid_to"]).format("YYYY-MM-DD") + " 23:59:59";
    delete clone.vouchers;
    if (clone.id !== null) {
      dispatch(
        voucherTypesActions.patchVoucherType({
          token: Biscuit.get("token"),
          id: clone.id,
          data: clone,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setVoucherTypePending(true);
    } else {
      delete clone.id;
      dispatch(
        voucherTypesActions.addVoucherType({
          token: Biscuit.get("token"),
          data: clone,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setVoucherTypePending(true);
    }
  };

  const close = () => {
    dispatch(voucherTypesActions.getVoucherTypesResetData());
    let requestPath = "";
    if (
      typeof props.requestPath !== "undefined" &&
      !props.requestPath.includes("/vouchers/" + voucherType.id)
    ) {
      requestPath = props.requestPath;
    }
    let currentURL = "";
    if (!currentUrl.search.includes("/vouchers/" + voucherType.id)) {
      currentURL = currentUrl.search;
    }
    let returnUrl = requestPath !== "" ? requestPath + currentURL : `/vouchers${currentURL}`;
    console.log("returnUrl", returnUrl);
    window.location.replace(returnUrl);

    //props.setIndex(null);
    /* props.setResource([]);
        props.setIndex(null);
        //setToggleItemView(false);
        props.setAdd(false);
        alert('set Resource Changed');
        props.setResourcesPending(true);
        props.filterChangedHandle(props.filter);*/
    // props.onClose();
  };

  const onChangeType = (e) => {
    let clone = {};
    Object.assign(clone, voucherType);
    clone.type = e.target.value;
    setVoucherType(clone);
  };

  const onChangeUseFor = (e) => {
    if (e.target.value === "switch") return;
    let clone = {};
    Object.assign(clone, voucherType);
    clone.use_for = e.target.value;
    setVoucherType(clone);
  };

  const onChangeVoucherUnit = (e) => {
    let clone = {};
    Object.assign(clone, voucherType);
    clone.voucher_unit = e.target.value;
    setVoucherType(clone);
  };

  const onVoucherCodes = (e) => {
    setCodesGenerate(e.target.value);
    /* switch(e.target)
       {
           case 'voucher_codes_upload_file':
               let files = e.target.files, f = files[0];
               let reader = new FileReader();

               reader.onload = function(e) {
                   let data = e.target.result;
                   let workbook = XLSX.read(data, {type: 'binary'});
                   let result = [];

                   workbook.SheetNames.forEach(function(sheetName) {
                       let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {header:1});
                       roa.forEach((rowData) => {
                           rowData.forEach((cellData) => {
                               result = result.concat(String(cellData).replace(/\s/g, ''));
                           });
                       });
                   });
                   result = _.sortBy(_.uniq(result));
                   that.model.set('codes_area', result.join("; "));
               };

               reader.readAsBinaryString(f);
       }*/
  };

  const getUsernameById = (id) => {
    if (typeof id === "undefined" || id == null) return t("unknown", null, "capital");

    if (createdBy.id == id) {
      if (createdBy.first_name == "" && createdBy.last_name == "")
        return t("unknown", null, "capital");
      if (createdBy.first_name == "") return createdBy.last_name;
      if (createdBy.last_name == "") return createdBy.first_name;
      return createdBy.first_name + " " + createdBy.last_name;
    }

    if (modifiedBy.id == id) {
      if (modifiedBy.first_name == "" && modifiedBy.last_name == "")
        return t("unknown", null, "capital");
      if (modifiedBy.first_name == "") return modifiedBy.last_name;
      if (modifiedBy.last_name == "") return modifiedBy.first_name;
      return modifiedBy.first_name + " " + modifiedBy.last_name;
    }
    return t("unknown", null, "capital");
  };

  // useEffect(() => {

  /*

        var isNewItem = (document.location.href.indexOf('add') >= 0);

        if (isNewItem) {
            if (_postVoucherType.success === true) {
                showNotification('success', _postVoucherType.data.name);
                _postVoucherType.dispatch(voucherTypesActions.getVoucherTypeResetData());
                setVoucher(null);
                abortButtonRef.current.click();
            } else if (_postVoucherType.success === false) {
                showNotification('warning', 0, typeof _postVoucherType.data !== 'undefined' ? _postVoucherType.data.message : null);
                dispatch(voucherTypesActions.getVoucherTypeResetData());
                setVoucher(null);
                abortButtonRef.current.click();
            }
        } else {
            if (_patchVoucherType.success === true) {
                showNotification('success', _patchVoucherType.data.name);
                dispatch(voucherTypesActions.getVoucherTypeResetData());
                setVoucher(null);
                abortButtonRef.current.click();
            } else if (_patchVoucherType.success === false){
                showNotification('warning', voucherType.name,typeof _patchVoucherType.data !== 'undefined' ? _patchVoucherType.data.message : null);
                dispatch(voucherTypesActions.getVoucherTypeResetData());
                setVoucher(null);
                abortButtonRef.current.click();
            }
        }
*/

  //   }, [_postVoucherType,_patchVoucherType]);

  useEffect(() => {
    if (_user.success === "") return;
    if (voucherType.created_by === _user.data.id) {
      setCreatedBy({ ..._user.data });

      if (typeof voucherType.modified_by !== "undefined" && voucherType.modified_by != null) {
        props.dispatch(
          userActions.getUser({
            token: Biscuit.get("token"),
            id: voucherType.modified_by,
          }),
        );
      }
      setUserPending(false);
      return;
    }

    if (voucherType.modified_by === _user.data.id) {
      setModifiedBy({ ..._user.data });
      setUserPending(false);
      return;
    }
  }, [_user]);

  const _getFormattedTime = (date) => {
    let total = moment(new Date(date)).format("YYYY-MM-DD");
    total += " 00:00:00";
    return total;
  };

  const onChangeForm = (e) => {
    let clone = {};
    Object.assign(clone, voucherType);
    switch (e.target.name) {
      case "name":
        clone.name = e.target.value;
        break;
      case "status":
        clone.status = e.target.checked;
        break;
      case "description":
        clone.description = e.target.value;
        break;
      case "voucher_value":
        clone.voucher_value = e.target.value;
        break;
      case "voucher_unit":
        clone.voucher_unit = e.target.value;
        break;
      case "contingent_number":
        clone.contingent_number = e.target.value;
        break;
      case "multiple_use":
        clone.multiple_use = e.target.checked;
        break;
      case "sellable":
        clone.mac = e.target.checked;
        break;
      case "days_number":
        clone.days_number = e.target.value;
        break;
    }
    setVoucherType(clone); // set object state
  };

  const onChangeValidTo = (date) => {
    if (date !== "") {
      setTimespan({
        ...timespan,
        valid_to: date,
      });
      let clone = {};
      Object.assign(clone, voucherType);
      clone.valid_to = _getFormattedTime(date);
      setVoucherType(clone);
    }
  };

  const isBlank = (str) => {
    return !str || /^\s*$/.test(str);
  };

  const onRemoveCode = (id) => {
    let newCodes = [];
    Object.keys(codes).map((key) => {
      if (codes[key].value.toString() !== id.toString()) {
        newCodes.push(codes[key]);
      }
    });

    let newAmounts = [];
    let clone = {};
    Object.assign(clone, amounts);

    Object.keys(amounts).map((key) => {
      if (key !== id) {
        newAmounts[key] = amounts[key];
      }
    });
    setAmounts(null);
    setCodes(null);
    setCodesPending(true);
    setAmountsPending(true);
    setCodes(newCodes);
    setAmounts(newAmounts);
    setCodesPending(false);
    setAmountsPending(false);
    if (_.isNumber(id)) {
      dispatch(
        vouchersActions.deleteVoucher({
          token: Biscuit.get("token"),
          id: id,
        }),
      );
    }
  };

  const getQRCode = (id) => {
    if (!_.isNumber(id) && id.includes("code")) {
      alert(t("code must be saved to create a qr code", null, "capital"));
      return;
    }
    getDocHandler("/vouchers/getQRCode/" + id, "GET", "image/png", id + ".png");
  };

  const getCodeFromId = (id) => {
    let code = "";
    Object.keys(codes).map((key) => {
      if (codes[key].value.toString() === id.toString()) {
        code = codes[key].label;
        return;
      }
    });
    return code;
  };

  const copyToClipboard = (id) => {
    let code = getCodeFromId(id);
    console.log("code", code);
    navigator.clipboard.writeText(code).then(
      function () {},
      function (err) {
        console.error("Error: Failed to copy to clipboard: ", err);
      },
    );
  };

  const abortButtonRef = React.createRef();
  let returnUrl =
    typeof props.requestPath !== "undefined"
      ? props.requestPath + currentUrl.search + currentUrl.search
      : `/vouchers${currentUrl.search}`;
  const contextMenu = [
    {
      label: t("copy_to_clipboard", null, "capital"),
      id: "copy",
      onClick: "copyToClipboard",
    },
    {
      label: t("export vouchers", null, "capital"),
      id: "getQrCode",
      onClick: "getQRCode",
    },
    {
      label: t("delete_${a}", { a: t("voucher") }, "capital"),
      id: "delete",
      onClick: "onRemoveCode",
    },
  ];
  const setFile = (e) => {
    let files = e.target.files,
      f = files[0];
    setFiles(f);
  };

  const uploadFile = (e) => {
    if (files === null) return;
    let f = files;
    let reader = new FileReader();
    reader.onload = function (e) {
      let data = e.target.result;
      let workbook = XLSX.read(data, { type: "binary" });
      let result = [];

      workbook.SheetNames.forEach(function (sheetName) {
        let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
        });
        roa.forEach((rowData) => {
          rowData.forEach((cellData) => {
            result = result.concat(String(cellData).replace(/\s/g, ""));
          });
        });
      });
      result = _.sortBy(_.uniq(result));
      let v = [];
      if (voucherType.vouchers.length > 0) {
        v = voucherType.vouchers;
        v.map((va, key) => {
          if (isNaN(va.id) && va.id.includes("code")) {
            delete v[key];
          }
        });
      }
      let counter = 0;
      result.map((val) => {
        counter++;
        v.push({
          id: "code_" + counter,
          voucher_code: val,
          usage_count: 0,
        });
      });
      setCodes(null);
      setAmounts(null);
      setCodes(fill(v, "codes"));
      setAmounts(fill(v, "counts"));
      setCodesArea(result.join("; "));
    };

    reader.readAsBinaryString(f);
  };

  const setCount = (e) => {
    let count = Number(e.target.value);
    setVoucherCodesToGenerate(count);
  };
  const generateNewCodes = () => {
    if (voucherCodesToGenerate === null || voucherCodesToGenerate < 1) return;
    let body = {
      length: 5,
      amount: voucherCodesToGenerate,
    };
    dispatch(
      vouchersActions.getCodes({
        token: Biscuit.get("token"),
        data: body,
      }),
    );
    setGetCodesPending(true);
  };

  const contextFunctions = (name, e) => {
    switch (name) {
      case "copyToClipboard":
        copyToClipboard(e);
        break;
      case "getQRCode":
        getQRCode(e);
        break;
      case "onRemoveCode":
        onRemoveCode(e);
        break;
    }
  };

  const setText = () => {
    if (codesArea === null) return;
    let v = [];
    if (voucherType.vouchers.length > 0) {
      v = voucherType.vouchers;
      v.map((va, key) => {
        if (isNaN(va.id) && va.id.includes("code")) {
          delete v[key];
        }
      });
    }
    let newCodes = codesArea.split(";");
    let counter = 0;
    newCodes.map((code) => {
      counter++;
      v.push({
        id: "code_" + counter,
        voucher_code: code,
        usage_count: 0,
      });
    });
    setCodes(null);
    setAmounts(null);
    setCodes(fill(v, "codes"));
    setAmounts(fill(v, "counts"));
  };

  const generate = () => {
    switch (codesGenerate) {
      case "voucher_codes_generate":
        generateNewCodes();
        break;
      case "voucher_codes_upload_file":
        uploadFile();
        break;
      case "voucher_codes_enter_as_text":
        setText();
        break;
    }
  };

  const setCodesText = (e) => {
    setCodesArea(e.target.value);
  };

  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"></div>

      {rbac.hasPermission("editVoucher") && (
        <div
          className="off-canvas position-right is-transition-overlap is-open"
          id="inb-off-canvas"
          data-off-canvas="85mrb3-off-canvas"
          data-close-on-click="true"
          aria-hidden="false"
        >
          <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
            <h1 className="inb-page-title">
              {voucherType.id !== null
                ? t("edit_${a}", { a: t("voucher", null, "capital") })
                : t("add_${a}", { a: t("voucher", null, "capital") })}
            </h1>
            <div className="off-canvas__actions column">
              <button
                type="submit"
                className={
                  "button medium beautify beautify-" +
                  Biscuit.get("user.client_id") +
                  " button-submit round"
                }
                title="Speichern"
                onClick={onSubmit}
              >
                {!voucherTypePending ? (
                  <>
                    <i className="fi fi-check"></i>
                    <span>{t("save")}</span>
                  </>
                ) : (
                  <>
                    <span>
                      <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                      {t("save")}
                    </span>
                  </>
                )}
              </button>
              <a href="#">
                <button
                  ref={abortButtonRef}
                  type="button"
                  id="inb-resourcesform-abort-button"
                  className="button hollow secondary right button-abort round"
                  title="Fenster schließen"
                  onClick={() => close()}
                >
                  <i className="fi fi-x"> </i>
                </button>
              </a>
            </div>
          </header>
          {typeof voucherType.id !== "undefined" && voucherType.id != null && (
            <p className="off-canvas__subtitle off-canvas__header-region">
              {typeof voucherType.created !== "undefined" &&
                t("created_at") +
                  " " +
                  moment(voucherType.created).format("DD.MM.YYYY HH:mm:ss") +
                  " " +
                  t("edited_by") +
                  " " +
                  getUsernameById(voucherType.created_by) +
                  " | " +
                  t("last_modified_at") +
                  " " +
                  moment(voucherType.modified).format("DD.MM.YYYY HH:mm:ss") +
                  " " +
                  t("edited_by") +
                  " " +
                  getUsernameById(voucherType.modified_by)}
            </p>
          )}

          <form className="off-content row">
            <div className="inb-form-group column medium-3 small-12 username">
              <label className="inb-form__controlLabel">{t("name")}</label>
              <div className="inb-form__controllClass">
                <input
                  id="voucher_type_item_input_name"
                  type="text"
                  className="form-control"
                  name="name"
                  required=""
                  autoComplete="false"
                  placeholder=""
                  value={voucherType.name}
                  onChange={onChangeForm}
                />
              </div>
            </div>

            <div className="inb-form-group column medium-3 small-12 status">
              <label className="inb-form__controlLabel">{t("voucher_type")}</label>
              <div className="inb-form__controllClass">
                <select
                  className="inbooma-select-box__input"
                  name="type"
                  onChange={(e) => onChangeType(e)}
                  value={voucherType.type === null ? type : voucherType.type}
                >
                  {["discount", "gift_card"].map((typeD) => {
                    return (
                      <>
                        <option key={typeD} value={typeD}>
                          {t("voucher_type_" + typeD)}
                        </option>
                      </>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="inb-form-group column medium-6">&nbsp;</div>

            <div className="inb-form-group column medium-3 small-6 lang">
              <label className="inb-form__controlLabel">
                {t("voucher_type_valid_to", null, "capital")}
              </label>
              <div className="inb-form__controllClass">
                <DatePicker
                  className="noBorders-noBackground"
                  dateFormat="dd.MM.y"
                  id="valid_to"
                  label={t("valid_to")}
                  selected={timespan.valid_to}
                  onChange={(date) => onChangeValidTo(date)}
                  onKeyDown={(e) => {
                    if (e.keyCode === 8) e.preventDefault();
                  }}
                  placeholderText=""
                  style={{ width: "50%", paddingLeft: "10px;" }}
                  locale={de}
                />
              </div>
            </div>

            <div className="inb-form-group column medium-1 small-12 lang">
              <label className="inb-form__controlLabel">{t("active")}</label>
              <div className="inb-form__controllClass">
                <SwitchPaddle
                  name="status"
                  value={voucherType.status}
                  onChange={onChangeForm}
                  label={""}
                />
              </div>
            </div>

            <div className="inb-form-group column medium-3 small-12 lang">
              <label className="inb-form__controlLabel">{t("multiple_use")}</label>
              <div className="inb-form__controllClass">
                <SwitchPaddle
                  name="multiple_use"
                  value={voucherType.multiple_use}
                  onChange={onChangeForm}
                  label={""}
                />
              </div>
            </div>

            <div className="inb-form-group column medium-3 small-6 lang">
              <label className="inb-form__controlLabel">{t("use_for", null, "capital")}</label>
              <div className="inb-form__controllClass">
                <select
                  className="inbooma-select-box__input"
                  name="use_for"
                  onChange={(e) => onChangeUseFor(e)}
                  value={voucherType.use_for === null ? "switch" : voucherType.use_for}
                >
                  {["switch", "contingent", "reservation"].map((type) => {
                    return (
                      <>
                        <option key={type} value={type}>
                          {t(type)}
                        </option>
                      </>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="inb-form-group column medium-12 small-12 lang">
              <label className="inb-form__controlLabel">{t("description", null, "capital")}</label>
              <div className="inb-form__controllClass">
                <textarea name="description" onChange={onChangeForm} />
              </div>
            </div>

            <div className="inb-form-group column medium-3 small-6 lang">
              <label className="inb-form__controlLabel">{t("voucher_unit")}</label>
              <div className="inb-form__controllClass">
                <select
                  className="inbooma-select-box__input"
                  name="voucher_unit"
                  onChange={(e) => onChangeForm(e)}
                  value={voucherType.voucher_unit === null ? "" : voucherType.voucher_unit}
                >
                  {["percentage", "fix_price"].map((type) => {
                    return (
                      <>
                        <option key={type} value={type}>
                          {t("voucher_unit_" + type)}
                        </option>
                      </>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="inb-form-group column medium-3 small-6 lang">
              <label className="inb-form__controlLabel">{t("voucher_value")}</label>
              <div className="inb-form__controllClass">
                <input
                  type="number"
                  max={100}
                  min={0}
                  className="form-control"
                  name="voucher_value"
                  autoComplete="false"
                  value={voucherType.voucher_value === null ? "" : voucherType.voucher_value}
                  onChange={onChangeForm}
                  placeholder=""
                />
              </div>
            </div>
            <div className="inb-form-group column medium-6">&nbsp;</div>

            <div className="inb-form-group column medium-3 small-6 lang">
              <label className="inb-form__controlLabel">{t("days_number")}</label>
              <div className="inb-form__controllClass">
                <input
                  type="number"
                  min={0}
                  className="form-control"
                  name="days_number"
                  autoComplete="false"
                  value={voucherType.days_number === null ? "" : voucherType.days_number}
                  onChange={onChangeForm}
                  placeholder=""
                />
              </div>
            </div>
            <div className="inb-form-group column medium-9">&nbsp;</div>

            <div className="inb-form-group column medium-3 small-6 lang">
              <label className="inb-form__controlLabel">{t("contingent_number")}</label>
              <div className="inb-form__controllClass">
                <input
                  type="number"
                  min={0}
                  className="form-control"
                  name="contingent_number"
                  autoComplete="false"
                  value={
                    voucherType.contingent_number === null ? "" : voucherType.contingent_number
                  }
                  onChange={onChangeForm}
                  placeholder=""
                />
              </div>
            </div>
            <div className="inb-form-group column medium-9">
              <ContingentsChange
                voucherType={voucherType}
                setVoucherType={setVoucherType}
                dispatch={dispatch}
              />
            </div>

            <div className="inb-form-group column medium-12">
              <hr />
            </div>

            <div className="inb-form-group column medium-4 small-12">
              <label className="inb-form__controlLabel">
                {t("voucher_codes_source", null, "capital")}
              </label>
              <div className="inb-form__controllClass">
                <select
                  className="inbooma-select-box__input"
                  name="voucher_unit"
                  onChange={(e) => onVoucherCodes(e)}
                  value={codesGenerate}
                >
                  {[
                    "-",
                    "voucher_codes_enter_as_text",
                    "voucher_codes_upload_file",
                    "voucher_codes_generate",
                  ].map((type) => {
                    return (
                      <>
                        <option key={type} value={type}>
                          {t(type)}
                        </option>
                      </>
                    );
                  })}
                </select>
              </div>
            </div>
            {codesGenerate === "voucher_codes_upload_file" && (
              <>
                <div className="inb-form-group column medium-4 small-12">
                  <label className="inb-form__controlLabel">
                    {t("codes_file", null, "capital")}
                  </label>
                  <div className="inb-form__controllClass">
                    <input
                      type={"file"}
                      className={"formControl"}
                      name={"codes_file"}
                      maxLength={255}
                      onChange={setFile}
                    />
                  </div>
                </div>
              </>
            )}
            {codesGenerate === "voucher_codes_generate" && (
              <>
                <div className="inb-form-group column medium-2 small-12">
                  <label className="inb-form__controlLabel">
                    {t("voucher_codes_generate_count", null, "capital")}
                  </label>
                  <div className="inb-form__controllClass">
                    <input
                      type={"number"}
                      min={0}
                      max={999}
                      className={"formControl"}
                      name={"codes_generate_count"}
                      maxLength={255}
                      onChange={setCount}
                    />
                  </div>
                </div>
              </>
            )}
            {codesGenerate === "voucher_codes_enter_as_text" && (
              <>
                <div className="inb-form-group column medium-12 small-12 codes_area">
                  <label className="inb-form__controlLabel">
                    {t("voucher_codes_new", null, "capital")}
                  </label>
                  <div className="inb-form__controllClass">
                    <textarea
                      className="form-control "
                      name="codes_area"
                      maxLength="4000"
                      placeholder=""
                      required=""
                      onChange={setCodesText}
                    ></textarea>

                    <span className="help-text">{t("enter_codes_separate_by")}</span>
                  </div>
                </div>
              </>
            )}
            {codesGenerate !== "-" && (
              <>
                <div className="inb-form-group column medium-2 small-12">
                  <label className="inb-form__controlLabel">&nbsp;</label>
                  <div className="inb-form__controllClass">
                    <a
                      href="#"
                      className={
                        "button medium beautify beautify-" +
                        Biscuit.get("user.client_id") +
                        " button-submit round"
                      }
                      onClick={generate}
                    >
                      <span>{t("generate")}</span>
                    </a>
                  </div>
                </div>
              </>
            )}
            <div className="inb-form-group column medium-12">
              <hr />
            </div>
            {!amountsPending && !codesPending && amounts !== null && codes !== null && (
              <>
                <div className="inb-form-group column medium-12 small-12">
                  <div className="inb-form__controllClass">
                    <MultiSelectWithContextMenu
                      values={codes}
                      amounts={amounts}
                      options={contextMenu}
                      label={t("voucher_codes", null, "capital")}
                      name={"voucher_codes"}
                      extraClass={""}
                      contextFunctions={contextFunctions}
                      helpMessage={
                        "In den Klammern hinter dem Gutscheincode wird angezeigt, wie viele dieser Gutscheine bereits verwendet wurden. Bsp.: SOMMER (10) - Der Gutscheincode SOMMER wurde bereits 10 mal angewendet."
                      }
                    />
                  </div>
                </div>
              </>
            )}
          </form>
        </div>
      )}
    </>
  );
};

export default ItemView;
